import Button from "react-bootstrap/Button";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center p-4">
      <h1 className="text-6xl font-bold text-red-500">404</h1>
      <p className="text-xl mt-4">Oops! The page you are looking for does not exist.</p>
      <Button variant="primary" href="\">
            Home
        </Button>
    </div>
  );
}